import React from "react";
import "./CheckoutProcess.css";
import axios from "axios";
import queryString from "query-string";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import CheckoutInfo from "../CheckoutInfo/CheckoutInfo";
import AddressCollector from "../AddressCollector/AddressCollector";

import CheckoutForm from "../CheckoutForm/CheckoutForm";
import { FaShieldAlt, FaShippingFast, FaCheckCircle } from "react-icons/fa";
import { MdPhoneInTalk, MdCancel } from "react-icons/md";
const stripePromise = loadStripe(
  "pk_test_51H2IXBCa8jyr92y09VZyA0GXIvEb2mfipb5SHC3qVz8mdWgsi8i79nEtzo69JSf9qUZlbY8ATIWl1JDIae4jqmVY00b1qzOKlL"
);

export default class CheckoutProcess extends React.Component {
  state = {
    cart: {
      items: [],
      collectShippingAddress: false,
      collectBillingAddress: false,
      checkoutWallpaper: false,
    },
    shippingAddress: "",
    cartTotal: 0,
    shippingAddressDone: false,
    billingAddressDone: false,
    showCardElements: false,
    showShippingAddressCollector: true,
    showCheckoutInfo: false,
    endCheckoutSuccess: false,
    endCheckoutFailed: false,
    client_secret: "",
  };

  componentDidMount() {
    //GET CHECKOUT INFO
    let params = queryString.parse(window.location.search);
    const postData = {
      checkoutId: params.checkoutID,
    };
    axios
      .post(
        `https://zutp1rprgj.execute-api.eu-west-1.amazonaws.com/dev/checkout/get`,
        postData
      )
      .then((res) => {
        if (!res.data.checkoutData) {
          this.setState({ endCheckoutFailed: true });
          return;
        }
        const data = res.data.checkoutData.Item.cart;
        const client_secret = res.data.paymentIntent.client_secret;

        console.log(data);
        let cartTotal = 0;
        data.items.map((cartItem) => {
          return (cartTotal += parseInt(cartItem.price));
        });
        this.setState({
          cart: data,
          cartTotal: cartTotal,
          client_secret: client_secret,
          showCheckoutInfo: true,
        });
        if (!data.collectShippingAddress) {
          this.setState({
            showCardElements: true,
            showShippingAddressCollector: false,
          });
        }
      });
  }

  editShippingAddress = () => {
    this.setState({
      showCardElements: false,
      showShippingAddressCollector: true,
    });
  };

  updateShippingAddress = (shippingAddressData) => {
    console.log("Updating shipping address", shippingAddressData);
    this.setState({
      shippingAddress: shippingAddressData,
      showCardElements: true,
      showShippingAddressCollector: false,
    });
  };

  paymentLoading = () => {
    console.log("Payment Loading");
    let cart = this.state.cart;
    cart.collectShippingAddress = false;
    this.setState({ cart: cart });
  };

  completeCheckout = (status) => {
    if (status === "success") {
      this.setState({ endCheckoutSuccess: true });
    } else {
      this.setState({ endCheckoutFailed: true });
    }
  };

  render() {
    return (
      <div className="">
        {this.state.cart.checkoutWallpaper != "" ? (
          <div
            className="background_image"
            style={{
              backgroundImage: "url(" + this.state.cart.checkoutWallpaper + ")",
            }}
          ></div>
        ) : (
          false
        )}
        {!this.state.endCheckoutSuccess && !this.state.endCheckoutFailed ? (
          <div className="wideContainer checkoutProcess">
            <div className="checkout_bubbles">
              {this.state.showCheckoutInfo ? (
                <CheckoutInfo
                  cart={this.state.cart}
                  cartTotal={this.state.cartTotal}
                />
              ) : (
                false
              )}
              {this.state.cart.collectShippingAddress ? (
                <AddressCollector
                  outputAddress={this.updateShippingAddress}
                  showInputFields={this.state.showShippingAddressCollector}
                  editAddress={this.editShippingAddress}
                  addressLabel="Информация за доставката"
                />
              ) : (
                false
              )}
              {this.state.showCardElements ? (
                <Elements stripe={stripePromise}>
                  <CheckoutForm
                    checkoutState={this.state}
                    paymentLoading={this.paymentLoading}
                    completeCheckout={this.completeCheckout}
                  />
                </Elements>
              ) : (
                false
              )}
            </div>
          </div>
        ) : (
          false
        )}
        {this.state.endCheckoutSuccess ? (
          <div className="wideContainer checkoutProcess">
            <div>
              <FaCheckCircle color="green" size="60" />
              <br />
              <h3>Благодарим, ви!</h3>

              <div className="success_bubble">
                <div className="success_bubble_icon">
                  <MdPhoneInTalk />
                </div>
                <div className="success_bubble_message">
                  Очаквайте обаждане по телефона в работно време 09:00 - 17:00
                  за потвърждение на поръчката.
                </div>
              </div>
              <div className="success_bubble">
                <div className="success_bubble_icon">
                  <FaShippingFast />
                </div>
                <div className="success_bubble_message">
                  Доставката ще бъде изпратена в рамките на <b>24 до 48 часа</b>
                  .
                </div>
              </div>
            </div>
          </div>
        ) : (
          false
        )}
        {this.state.endCheckoutFailed ? (
          <div className="wideContainer checkoutProcess">
            <div>
              <MdCancel color="red" size="60" />
              <br />
              <h3>Възникна проблем при плащането!</h3>

              <div className="success_bubble">
                <div>
                  Не можахме да извършим плащане с вашата карта, моля опитайте с
                  друга карта.
                </div>
              </div>
            </div>
          </div>
        ) : (
          false
        )}
      </div>
    );
  }
}
